import { ChoiceGroup } from "@fluentui/react";
import React,{useContext,useEffect, useRef, useState}  from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { allReportTemplateCategory, choiceGroupStyles, clientReportTemplate, radiotemplateOptions } from "../../helper/initialData";
import { USERTYPES } from "../../../../constants/Constants";
import { t } from "i18next";
import { getEnv } from '../../../../helpers/EnvHelper';


const TemplateCategory = () => {

    const {
        selectedCategoryTemplate,
        setSelectedCategoryTemplate,
        modality,
        userRole,
        isClientReportExist,isRestrictionsEnabled,
        handleSwitchCategory,
        isDSRExists,
        setActiveTab,
        templateHeight,setTemplateHeight,
        disableEditReport
      } = useContext(studyReportContext);

      const templateRef = useRef(null);

      const [reportTemplateOptions, setReportTemplateOptions] = useState([]);

    const { showTemplateList,setShowTemplateList,setRSNAFlag } = useContext(studyReportContext);

    useEffect(() => {
      const options = getReportTemplate();
      setReportTemplateOptions(options);
  }, [isDSRExists, isClientReportExist, modality, userRole, disableEditReport]);


    useEffect(() => {
        if (templateRef.current) {
          const height = templateRef.current.offsetHeight;
          setTemplateHeight(height);
          if(reportTemplateOptions.length > 3){
            setTemplateHeight(70);
          }
        }
    }, [reportTemplateOptions]);

    const handleSelectType = (type) => {
      if(type == "rsnaReportTemplage"){
        setRSNAFlag(true);
      }else{
        setRSNAFlag(false);
      }
      setShowTemplateList(()=>{
          const newItem = {...showTemplateList};
          newItem.showTemplate = true;
          newItem.selectedList = type;
          return newItem;
      });
      setSelectedCategoryTemplate(type);
      if(type === "dsrTemplate") {
        setActiveTab(3);
      } else {
        setActiveTab(1);
      }
  }

  const getReportTemplate = () => {

    let reportTemplateOptions = [];

    reportTemplateOptions.push({
      key: 'deeptekReportTemplage',
      text:getEnv("REACT_APP_VDC_PLATFORM") == "true" ? t("report.vdc-report") : t("report.deeptek-report")
    });

    if(isClientReportExist){
      reportTemplateOptions.push({
        key: 'clientReportTemplate',
        text:"Client Report Template",
      });
    }

    if((userRole == USERTYPES.RADIOLOGIST || userRole == USERTYPES.TYPIST || (userRole == USERTYPES.FIRMADMIN && !disableEditReport))&& getEnv("REACT_APP_VDC_PLATFORM") == "false"){
      reportTemplateOptions.push({
        key: 'radiologistReportTemplate',
        text:t("report.radiologist-report"),
      });
    }

    if(modality.length > 0 &&
      modality != "MR" &&
      modality != "CT" &&
      (userRole == USERTYPES.RADIOLOGIST || userRole == USERTYPES.TYPIST || (userRole == USERTYPES.FIRMADMIN && !disableEditReport))&& getEnv("REACT_APP_VDC_PLATFORM") == "false"){
        reportTemplateOptions.push({
          key: 'rsnaReportTemplage',
          text:t("report.rsna-report"),
        });
      }
    

   

    return reportTemplateOptions;

    // Upper code is the updated logic as per ContextMenuTemplate compnoent
    // if(isRestrictionsEnabled && isClientReportExist){
    //   setSelectedCategoryTemplate("clientReportTemplate");
    //   return clientReportTemplate;
    // }

    // if(modality!=undefined && modality != "CR" && modality != "DX" ){
    //     if(isClientReportExist){    
    //       return allReportTemplateCategory.filter((item)=>item.key != "rsnaReportTemplage") 
    //     }
    //     return radiotemplateOptions.filter((item)=>item.key != "rsnaReportTemplage") 
    // }else{
    //     if(isClientReportExist){    
    //       return allReportTemplateCategory;
    //     }
    //     return radiotemplateOptions;
    // }
  }

  useEffect(()=>{
    if(isRestrictionsEnabled && isClientReportExist){
      setSelectedCategoryTemplate("clientReportTemplate");
      handleSwitchCategory("clientReportTemplate");
      handleSelectType("clientReportTemplate");
    }
  },[isRestrictionsEnabled, isClientReportExist])

    return (
      <div className="ms-Grid-row template-section-1"  >
        <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
          {(isRestrictionsEnabled && isClientReportExist) &&
            <ChoiceGroup
              ref={templateRef}
              className="report-template-radio"
              styles={choiceGroupStyles}
              value={'clientReportTemplate'}
              defaultSelectedKey={'clientReportTemplate'}
              options={[{
                key: 'clientReportTemplate',
                text:t("report.client-report"),
              }]}
              onChange={(e, val) => {
                handleSelectType(val.key);
              }}
            />
          }
          { !(isRestrictionsEnabled && isClientReportExist) &&
             <ChoiceGroup
             ref={templateRef}
             className="report-template-radio"
             styles={choiceGroupStyles}
             value={selectedCategoryTemplate}
             selectedKey={selectedCategoryTemplate}
             options={reportTemplateOptions}
             onChange={(e, val) => {
               handleSelectType(val.key);
             }}
           />
          }
        </div>
      </div>
    );
};

export default TemplateCategory;